export default "__VITE_ASSET__BtpYkryx__"